import { apiGetRequest, apiPostRequest } from "../utils/webrequests";
import { EventResponse} from "../data/registration";


        export async function getUserResponse(eventId: string, userId: string): Promise<EventResponse | null> {
            try {
                const result = await apiGetRequest(`events/${eventId}/registration/${userId}`, null);

                if (result) {
                    return {
                        eventId: result.EventId,
                        userId: result.UserId,
                        paymentId: result.PaymentId ?? "",
                        submitted: result.Submitted,
                        checkIn: result.checkIn,
                        checkInTime: result.checkInTime,
                        responses: result.Responses?.map((r: any) => ({
                            questionId: r.QuestionId,
                            answers: r.Answers
                        })) ?? []
                    };
                }

                return null;
            } catch (error: any) {
                console.error("Failed to fetch user response:", error);
                return null;
            }
        }


        export async function updateUserResponse(response: EventResponse): Promise<boolean> {
            try {
                if (!response.eventId || !response.userId) {
                    console.error("Missing eventId or userId in response:", response);
                    return false;
                }

                // Deduplicate by QuestionId
                const deduped = Object.values(
                    response.responses.reduce((acc, curr) => {
                        acc[curr.questionId] = curr; // replaces any duplicate
                        return acc;
                    }, {} as Record<string, any>)
                );

                // Prepare payload using PascalCase keys expected by backend
                const payload = {
                    EventId: response.eventId,
                    UserId: response.userId,
                    Submitted: response.submitted,
                    checkIn: response.checkIn,
                    checkInTime: response.checkInTime,
                    Responses: deduped.map(r => ({
                        QuestionId: r.questionId,
                        Answers: r.answers
                    }))
                };

                await apiPostRequest(`events/${response.eventId}/registration/${response.userId}`, payload);
                return true;
            } catch (error: any) {
                console.error("Failed to update response:", error);
                return false;
            }
        }

        const BASE_API_URL = "http://localhost:7071";

        export async function deleteUserResponse(eventId: string, userId: string): Promise<boolean> {
            try {
                const res = await fetch(`${BASE_API_URL}/api/events/${eventId}/registration/${userId}`, {
                    method: "DELETE"
                });
                return res.ok;
            } catch (error: any) {
                console.error("Error deleting registration:", error);
                return false;
            }
        }

        export async function deleteQuestionFromResponse(eventId: string, userId: string, questionId: string): Promise<boolean> {
            try {
                const res = await fetch(`${BASE_API_URL}/api/events/${eventId}/registration/${userId}/question/${questionId}`, {
                    method: "DELETE"
                });
                return res.ok;
            } catch (error: any) {
                console.error("Error deleting question from response:", error);
                return false;
            }
        }

export async function getRegisteredEventIds(userId: string): Promise<string[]> {
    try {
        const result = await apiGetRequest(`users/${userId}/events`, null);
        return Array.isArray(result) ? result : [];
    } catch (error) {
        console.error("Failed to fetch registered event IDs:", error);
        return [];
    }
}







